// extracted by mini-css-extract-plugin
export default {"root":"styles_root__H2hQ+","button":"styles_button__thtVS","info":"styles_info__EVg32","imageBlock":"styles_imageBlock__Pq24p"};